//import React from 'react';
import cmsUtils from '../../../cms/utils/cmsUtils';
import utils from '../../../utils';
import { SiteLink } from '../../../components';

/** @jsx jsx */
import { jsx } from '@emotion/core'
import style from './style';

export function PageTilesBsyc(props) {
  const item = props.item;
  //const detailHoverBgColor = props.detailHoverBgColor ? props.detailHoverBgColor : "black";
  const cmsOption = props.cmsOption || {};
  const pages = getPages(cmsUtils.payload(item, 'PageObjects'));
  const mobile = utils.css.screenWidth() <= 550;
  const pageTileElts = pages.map((page, index) =>
    <Tile page={page} key={index} disableLink={cmsOption.isCmsEdit} idx = {index} mobile = {mobile}></Tile>
  );

  //const cssClass = utils.classNames('cms_item', 'pageTiles tiles', item.cssClass || item.anchorName || '');
  const cssClass = utils.classNames('cms_item', 'pageTiles__small2', item.cssClass || item.anchorName || '');

  return (
    <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}
     css = {style.pageTiles}>
      {pageTileElts}
    </div>
  );
}

function getPages(pagesSerialized) {
  if (pagesSerialized) {
    return JSON.parse(pagesSerialized);
  }
  return [];
}

function Tile(props) {
  const page = props.page;
  const imageUrl = utils.site.resourcePath(page.imageUrl);
  const disableLink = props.disableLink;
  const colorTheme = page.colorTheme;
  const index = props.idx;
  //const mobile = props.mobile
  
  return (
    <div css = {style.pageTile__tile} className="pageTile__small2">
      <SiteLink className="pageTile__small2__content" css = {style.tile__content} to={disableLink ? '' : page.pageUrl}>
        <div css={style.tile__flip__wrapper}>
          <div className="pageTile__small2__bg" data-aos={index % 2 === 0 ? 'flip-up' : 'flip-down'} css = {style.tile__bg} style={{ backgroundImage: utils.css.bgUrlStyle(imageUrl) }}></div>
          <div css={style.tile__details} className={`pageTile__small2__content__details ${colorTheme}`} data-aos={index % 2 === 0 ? 'flip-down' : 'flip-up'}>  
            <div className="pageTile__small2__container">
              {
                (page.pageTitle && page.pageTitle !== '') &&
                <div className="pageTile__small2__title">
                  {page.pageTitle}
                </div>
              }
              <div className="pageTile__small2__desc">
                {page.tileDesc || page.description}
              </div>
              <div className="pageTile__small2__button">
                LEARN MORE
              </div>
            </div>
          </div>
        </div>
      </SiteLink>
    </div>
  )
}